import React from 'react';
import { useTranslation } from 'react-i18next';
import Torpedo from '@wix/da-shared-react/pkg/Torpedo/DeviationTorpedo';
import DuperbrowseContext from '../../../../contexts/DuperbrowseContext';
import { MeasuredCookieType } from '@wix/da-shared-react/pkg/Measured';
import { BiLoggerContextProvider } from '@wix/da-shared-react/pkg/biLogger';
import { PapiDeviation, PapiUser } from '@wix/da-types-papi';
import { GallectionType } from '../../../../../types/gallection';

export interface Props {
  streamId: string;
  gallectionType: GallectionType;
  gallectionOwner?: PapiUser;
  deviations: PapiDeviation[];
}

const TORPEDO_DEFAULT_SIZE = {
  desktop: { width: 1024, height: 0 },
  mobile: { width: 320, height: 0 },
};
const TORPEDO_CONTAINER_SIZE = { width: 1024 };

export const GallectionDeviationsTorpedo: React.FC<Props> = ({
  streamId,
  deviations,
  gallectionType,
  gallectionOwner,
}) => {
  const { t } = useTranslation();
  return (
    <DuperbrowseContext
      streamId={streamId}
      deviations={deviations}
      parent={{
        title: gallectionOwner ?
          gallectionOwner.username : t(
            gallectionType === GallectionType.GALLERY
              ? 'navigation.route.gallery'
              : 'navigation.route.favourites'
          )
      }}
    >
      <BiLoggerContextProvider
        value={{ widgetname: 'folder_deviations' }}
      >
        <Torpedo
          cookieType={MeasuredCookieType.USER_PROFILE_GALLECTION_CONTENT}
          cookieDim={'width'}
          defaultSize={TORPEDO_DEFAULT_SIZE}
          container={TORPEDO_CONTAINER_SIZE}
          items={deviations}
        />
      </BiLoggerContextProvider>
    </DuperbrowseContext>
  );
};
GallectionDeviationsTorpedo.displayName = 'GallectionDeviationsTorpedo';

export default GallectionDeviationsTorpedo;
